import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0x3BA1566ED39F865bAf4c1Eb9acE53F3D2062bE65":
          "Re7 Labs Euler Sonic Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0xB672Ea44A1EC692A9Baf851dC90a1Ee3DB25F1C4": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
  [
    "k3-capital",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0xdD84A24eeddE63F10Ec3e928f1c8302A47538b6B":
          "K3 Capital Fireblocks Multisig",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "keyring",
    {
      name: "Keyring",
      logo: "entities/keyring.svg",
      description: "Enhanced depositor protection with instant zkVerification.",
      url: "https://keyring.network/",
      addresses: {
        "0x69cC425B1E5f302e7Db4E5d125ab984EC5186364": "Keyring Multisig",
      },
      social: { twitter: "keyringnetwork", github: "keyring-network" },
    },
  ],
  [
    "reservoir-labs",
    {
      name: "Reservoir Labs",
      logo: "entities/reservoir-labs.png",
      description: "Simply Efficient Defi",
      url: "https://reservoir.fi",
      addresses: {
        "0xAcE9D0c885f1c241C336B63D36CDe44e34e8B391": "Reservoir Labs Multisig",
      },
      social: { twitter: "ReservoirFi", github: "reservoir-labs" },
    },
  ],
  [
    "9summits",
    {
      name: "9 Summits",
      logo: "entities/9summits.png",
      description:
        "By curating top-performing vaults, we empower our clients to access the best opportunities in decentralized finance with confidence and precision.",
      url: "https://9summits.io/",
      addresses: {
        "0x23E6aecB76675462Ad8f2B31eC7C492060c2fAEF":
          "9 Summits vault Admin Multisig",
      },
      social: { twitter: "nine_summits" },
    },
  ],
])
